export default function isStore(businessType: string) {
  return businessType === 'store'
}
